import React from 'react';

const ReferralProgramModal = ({notifications, currentUserId, handleModalClose}) => {

  const updateNotification = (notification) => {
    $.ajax({
      type: 'put',
      url: `/users/${currentUserId}/notifications/${notification.id}/update_notification`,
      success: function(res) {
        handleModalClose(notifications);
      }
    })
  }

  return (
    <div data-reveal className='reveal-modal' id='guest-editor-alert-modal'>
      <div className='modal-body'>
        <div className='modal-close'>
          <a href='#' className='cancel-modal'>
            <img src="https://public.cureus.com/close_x.png"/>
          </a>
        </div>
      </div>
      <div className='modal-content'>
        <div className='image'>
          <img src="https://public.cureus.com/bell-alerts/guest-editor-alert-modal.png" />
        </div>
        <h4 className='title'>{notifications[0].title}</h4>
        <div className='message'>
          <p>{notifications[0].message}</p>
        </div>
        <a href={notifications[0].url} className='button primary' onClick={()=> updateNotification(notifications[0])}>{notifications[0].btn_text}</a>
      </div>
    </div>
  )
}

export default ReferralProgramModal;